(() => {
  const sections = document.querySelectorAll('[data-vrs-returns-hub]');

  sections.forEach((section) => {
    if (section.dataset.vrsReturnsInit === 'true') return;
    section.dataset.vrsReturnsInit = 'true';

    const items = section.querySelectorAll('.vrs-returns-hub__item');
    const checkbox = section.querySelector('[data-vrs-returns-consent]');
    const button = section.querySelector('[data-vrs-returns-button]');

    const setClosed = (answer) => {
      answer.style.height = '0px';
      answer.style.opacity = '0';
    };

    const setOpenAuto = (answer) => {
      answer.style.height = 'auto';
      answer.style.opacity = '1';
    };

    const openItem = (item, answer) => {
      item.dataset.animating = 'true';
      item.setAttribute('open', '');
      setClosed(answer);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          answer.style.height = `${answer.scrollHeight}px`;
          answer.style.opacity = '1';
        });
      });

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        setOpenAuto(answer);
        item.dataset.animating = 'false';
        answer.removeEventListener('transitionend', onEnd);
      };

      answer.addEventListener('transitionend', onEnd);
    };

    const closeItem = (item, answer) => {
      item.dataset.animating = 'true';
      answer.style.height = `${answer.scrollHeight}px`;
      answer.style.opacity = '1';
      answer.offsetHeight;
      answer.style.height = '0px';
      answer.style.opacity = '0';

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        item.removeAttribute('open');
        item.dataset.animating = 'false';
        answer.removeEventListener('transitionend', onEnd);
      };

      answer.addEventListener('transitionend', onEnd);
    };

    items.forEach((item) => {
      const summary = item.querySelector('.vrs-returns-hub__summary');
      const answer = item.querySelector('.vrs-returns-hub__answer');

      if (!summary || !answer) return;

      if (item.hasAttribute('open')) {
        setOpenAuto(answer);
      } else {
        setClosed(answer);
      }

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (item.dataset.animating === 'true') return;

        if (item.hasAttribute('open')) {
          closeItem(item, answer);
        } else {
          openItem(item, answer);
        }
      });
    });

    if (checkbox && button) {
      const syncButton = () => {
        const enabled = checkbox.checked && button.dataset.link && button.dataset.link.trim() !== '';
        button.disabled = !enabled;
        button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        button.classList.toggle('is-disabled', !enabled);
      };

      checkbox.addEventListener('change', syncButton);
      syncButton();

      button.addEventListener('click', () => {
        if (button.disabled) return;
        const link = button.dataset.link;
        if (link) window.location.href = link;
      });
    }
  });
})();
